import { useState, useEffect } from 'react'
import Home from '@/pages/home'
import Manifesto from '@/pages/manifesto'
import Roadmap from '@/pages/roadmap'
import About from '@/pages/about'
import Contact from '@/pages/contact'
import ArticlePage from '@/pages/article'
import CaseScoder from '@/pages/case-scoder'
import CaseJhsf from '@/pages/case-jhsf'
import Institucional from '@/pages/institucional'
import Privacy from '@/pages/privacy'
import Terms from '@/pages/terms'
import NotFound from '@/pages/not-found'
import { getPath, onPathChange } from '@/lib/navigation'

function App() {
  const [path, setPath] = useState(getPath())

  useEffect(() => {
    return onPathChange(() => setPath(getPath()))
  }, [])

  const articleMatch = path.match(/^\/article\/([a-z0-9-]+)\/?$/)
  if (articleMatch) {
    return <ArticlePage slug={articleMatch[1]} />
  }

  switch (path) {
    case '/':
      return <Home />
    case '/manifesto':
      return <Manifesto />
    case '/roadmap':
      return <Roadmap />
    case '/about':
      return <About />
    case '/contact':
      return <Contact />
    case '/institucional':
      return <Institucional />
    case '/case-scoder':
      return <CaseScoder />
    case '/case-jhsf':
      return <CaseJhsf />
    case '/privacy':
      return <Privacy />
    case '/terms':
      return <Terms />
    default:
      return <NotFound />
  }
}

export default App
